import React from 'react';
import ContactForm from '../Contact/ContactForm';

const ShareIdeaForm = () => {
    return (
        <section style={{ padding: '100px 0', background: '#fff', position: 'relative', overflow: 'hidden' }}>
            {/* Background Decoration */}
            <div style={{
                position: 'absolute',
                top: '-10%',
                right: '-10%',
                width: '600px',
                height: '600px',
                background: 'radial-gradient(circle, rgba(255,193,7,0.05) 0%, rgba(255,255,255,0) 70%)',
                borderRadius: '50%',
                zIndex: 0
            }}></div>

            <div className="container" style={{ position: 'relative', zIndex: 1, maxWidth: '1280px', margin: '0 auto', padding: '0 30px' }}>
                <div className="row align-items-center">
                    {/* Left Column: Content */}
                    <div className="col-lg-5 mb-50">
                        <div style={{ position: 'relative' }}>
                            <span style={{
                                display: 'inline-block',
                                padding: '8px 16px',
                                background: '#fff9e6',
                                color: '#b45309',
                                borderRadius: '100px',
                                fontSize: '13px',
                                fontWeight: '700',
                                textTransform: 'uppercase',
                                letterSpacing: '0.1em',
                                marginBottom: '24px'
                            }}>
                                🚀 Let's Build the Future
                            </span>
                            <h2 style={{ fontSize: '48px', fontWeight: '800', lineHeight: '1.2', color: '#111827', marginBottom: '24px' }}>
                                Have a <span style={{ color: '#ffc107', position: 'relative' }}>Great Idea?</span><br />
                                Let's bring it to life.
                            </h2>
                            <p style={{ fontSize: '18px', lineHeight: '1.7', color: '#6b7280', marginBottom: '40px' }}>
                                Every great product starts with a spark. Whether you have a detailed specification or just a rough concept, we're here to help you refine, design, and build it into a world-class solution.
                            </p>

                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {['Confidentiality Guaranteed (NDA)', 'Expert Technical Consultation', 'Detailed Project Roadmap'].map((item, i) => (
                                    <li key={i} style={{ display: 'flex', alignItems: 'center', marginBottom: '16px', fontSize: '16px', color: '#374151', fontWeight: '500' }}>
                                        <div style={{
                                            width: '24px',
                                            height: '24px',
                                            borderRadius: '50%',
                                            background: '#ffc107',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginRight: '12px',
                                            color: '#000'
                                        }}>
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                                <polyline points="20 6 9 17 4 12"></polyline>
                                            </svg>
                                        </div>
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    {/* Right Column: Form */}
                    <div className="col-lg-6 offset-lg-1">
                        <div style={{
                            background: '#ffffff',
                            borderRadius: '24px',
                            padding: '40px',
                            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.1)',
                            border: '1px solid #f3f4f6',
                            position: 'relative'
                        }}>
                            <h3 style={{ marginBottom: '30px', fontSize: '28px', fontWeight: '800', color: '#111827' }}>
                                Have a Project?
                            </h3>
                            <ContactForm
                                submitBtnClass="readon learn-more submit"
                                btnText="Submit Your Idea"
                                subjectPlaceholder="What is your idea?"
                                messagePlaceholder="Tell us about your idea..."
                            />
                        </div>
                    </div>
                </div>
            </div>
            <style>{`
                /* Ensure contact form inputs match the theme roughly */
                #contact-form .from-control {
                    background: #f9fafb;
                    border: 1px solid #e5e7eb;
                    border-radius: 12px;
                    padding: 16px 20px;
                    height: auto;
                    width: 100%;
                }
                #contact-form .from-control:focus {
                    border-color: #ffc107;
                }
                #contact-form textarea.from-control {
                    min-height: 200px;
                }
                #contact-form .submit {
                   width: 100%;
                   border-radius: 12px;
                   background: #ffc107;
                   color: #000;
                   text-align: center;
                   justify-content: center;
                   font-weight: 700;
                }
                #contact-form .submit:hover {
                    background: #111827;
                    color: #fff;
                }
                
                @media (max-width: 991px) {
                    h2 { font-size: 36px !important; }
                    .offset-lg-1 { margin-left: 0 !important; }
                }
            `}</style>
        </section>
    );
};

export default ShareIdeaForm;
